export function GlobalLoadingListener() {
  // Disabled - loading indicator removed per user request
  return null;
}
